import { render, staticRenderFns } from "./fText.template?vue&type=template&id=9c72d2ca&lang=pug&"
import script from "./fText.client?vue&type=script&lang=ts&"
export * from "./fText.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c72d2ca')) {
      api.createRecord('9c72d2ca', component.options)
    } else {
      api.reload('9c72d2ca', component.options)
    }
    module.hot.accept("./fText.template?vue&type=template&id=9c72d2ca&lang=pug&", function () {
      api.rerender('9c72d2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fText/fText.component.vue"
export default component.exports